import { render } from "./deduct.vue?vue&type=template&id=458e68e3&scoped=true"
import script from "./deduct.vue?vue&type=script&lang=js"
export * from "./deduct.vue?vue&type=script&lang=js"

import "./deduct.vue?vue&type=style&index=0&id=458e68e3&lang=scss&scoped=true"

import exportComponent from "/home/lcs/jenkins/workspace/v2-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-458e68e3"]])

export default __exports__